import { createContext, useContext } from 'react';

interface DialogContextValue {
  open?: boolean;
  closing: boolean;
  close: () => void;
  openDialog: () => void;
}

export const DialogContext = createContext<DialogContextValue | null>(null);

export const useDialog = () => {
  const context = useContext(DialogContext);

  if (!context) {
    throw new Error('Dialog components must be used within Dialog.Root');
  }

  return context;
};
